export default __webpack_public_path__ + "static/media/pro-elevate-dmb-banner-2.70e21234.jpg";